import { Properties } from '@crm/types'
import { Text } from '@shared/components'
import { Badge, Dropdown, Tag } from 'antd'
import { BadgeProps } from 'antd/lib'
import { useTheme } from 'antd-style'

import { useTranslation } from 'react-i18next'

import { CopyableText } from '../CopyableText'
import { useStyle } from './styles'

type Props = {
  phoneNumbers?: Properties[]
} & BadgeProps

export const PhoneNumbers = ({ phoneNumbers, ...props }: Props) => {
  const { styles } = useStyle()
  const { t } = useTranslation()
  const theme = useTheme()
  const primaryPhoneNumber = phoneNumbers?.find(
    (phone) => phone?.is_primary
  )?.number

  const dropdownMenu = phoneNumbers
    ?.filter((phone) => !phone?.is_primary)
    .map((phoneNumber) => ({
      key: phoneNumber?.id,
      label: (
        <CopyableText
          text={`+${phoneNumber?.number}`}
          className={styles.text}
          label={
            <a href={`tel:+${phoneNumber?.number}`}>+{phoneNumber?.number}</a>
          }
        />
      )
    }))

  const extraPhoneNumbersCount =
    phoneNumbers && phoneNumbers.length > 1 ? phoneNumbers.length - 1 : null

  if (!primaryPhoneNumber) return '-'

  return (
    <Dropdown
      menu={{
        onClick: (e) => e.domEvent.stopPropagation(),
        items: [
          ...(extraPhoneNumbersCount
            ? [
                {
                  key: 'title',
                  label: <Text>{t('lead.secondary_phone_numbers')}</Text>
                }
              ]
            : []),
          ...(dropdownMenu || [])
        ]
      }}
      trigger={['hover']}
    >
      <Badge
        {...props}
        color={theme.colorPrimary}
        count={extraPhoneNumbersCount && `+${extraPhoneNumbersCount}`}
      >
        <Tag>
          <CopyableText
            className={styles.text}
            text={`+${primaryPhoneNumber}`}
            label={
              <a href={`tel:+${primaryPhoneNumber}`}>+{primaryPhoneNumber}</a>
            }
          />
        </Tag>
      </Badge>
    </Dropdown>
  )
}
